import { Outlet } from 'react-router-dom';
import '../index.css'

function App() {
  return (
    <div>
    <Outlet/>
    </div>
  );
}

export default App;
